import './bannerPlaceholder.scss';
import React from 'react';

const BannerPlaceholder = React.forwardRef((props, ref) => (
    <div ref={ref} className="apps-banner-placeholder">
        <div className="default-banner-item-layout">
            <div className="layout-content" />
        </div>
    </div>
));

export default BannerPlaceholder;
